import {createBrowserRouter, createRoutesFromElements, Route} from "react-router-dom";
import Login from "pages/auth/login";
import React from "react";
import MasterContainer from "../shared/components/container";
import PoliticaDePrivacidade from "../pages/auth/politica-de-privacidade";
import ResetPasswordPage from "../pages/password/reset-password";
import LostPasswordPage from "../pages/password/lost-password";
const TorreTableDemoPage = React.lazy(() => import("../pages/dev/TorreTableDemoPage"));
const ProgrammingExportDemoPage = React.lazy(() => import("../pages/dev/ProgrammingExportDemoPage"));
const ProgrammingAuditDemoPage = React.lazy(() => import("../pages/dev/ProgrammingAuditDemoPage"));
const TripClosureDemoPage = React.lazy(() => import("../pages/dev/TripClosureDemoPage"));

export const authRoutes = createBrowserRouter(createRoutesFromElements(<>
        {process.env.NODE_ENV === 'development' && (
            <Route path="dev/torre-table-demo" element={<React.Suspense fallback={null}><TorreTableDemoPage /></React.Suspense>} />
        )}
        {process.env.NODE_ENV === 'development' && (
            <Route path="dev/programming-export-demo" element={<React.Suspense fallback={null}><ProgrammingExportDemoPage /></React.Suspense>} />
        )}
        {process.env.NODE_ENV === 'development' && (
            <Route path="dev/programming-audit-demo" element={<React.Suspense fallback={null}><ProgrammingAuditDemoPage /></React.Suspense>} />
        )}
        {process.env.NODE_ENV === 'development' && (
            <Route path="dev/trip-closure-demo" element={<React.Suspense fallback={null}><TripClosureDemoPage /></React.Suspense>} />
        )}
        <Route
            path="politica-de-privacidade"
            element={<PoliticaDePrivacidade/>}/>
        <Route
            path="/"
            element={<Login/>}/>
        <Route
            path="*"
            element={<Login/>}/>
    <Route
        path="reset-password/:token"
        element={<ResetPasswordPage/>}/>

    <Route
        path="lost-password"
        element={<LostPasswordPage/>}/>
    </>));
